module.exports = __webpack_public_path__ + "img/Instagram-video.46e38c40.svg";